import {ViewMode} from '../../ui/components/common/data/DataView';
import {IToggleViewAction} from './types/view.types';

export const TOGGLE_VIEW_GRID = 'TOGGLE_VIEW_GRID';
export const TOGGLE_VIEW_TABLE = 'TOGGLE_VIEW_TABLE';

export const toggleViewAction = (view: ViewMode): IToggleViewAction => ({
    type: view === ViewMode.GRID ? TOGGLE_VIEW_GRID : TOGGLE_VIEW_TABLE,
});

export type ViewReducerType = IToggleViewAction;
